import { useEffect, useState } from 'react';

export type Countdown = {
  configured: boolean;
  ended: boolean;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

/** Cuenta regresiva hacia una fecha fija: es igual para todos y no se reinicia al recargar. */
export function useCountdown(target: string): Countdown {
  const end = target ? Date.parse(target) : NaN;
  const configured = !Number.isNaN(end);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!configured || Date.now() >= end) return;
    const id = window.setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= end) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [configured, end]);

  const diff = configured ? Math.max(0, end - now) : 0;
  const total = Math.floor(diff / 1000);

  return {
    configured,
    ended: configured && diff === 0,
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}
